import {DrawerProps} from '@mantine/core';
import {PlatformDrawer} from '@flexinet/ui-components';
import {RecordForm} from '../forms/RecordForm';
import {PaymentIntent} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: PaymentIntent,
        handleSubmit: (values: PaymentIntent) => void | Promise<unknown>
    }) => {

    const title = record?.id ? 'Edit Payment Intent' : 'Add Payment Intent';

    /**
     * ⚠️ MONEY PATH — the drawer closes only when the mutation RESOLVED.
     *
     * The `await` was already here, but it was awaiting `mutate`, which returns
     * `void` and resolves on the same tick. The drawer therefore closed the
     * instant submit was clicked, whatever the request went on to do — a failed
     * create looked identical to a successful one until the error notification
     * arrived over an already-dismissed form, with the operator's values gone.
     *
     * `usePaymentIntent` now hands back `mutateAsync`, so this await is real.
     * The rejection is left uncaught on purpose: `onClose()` below is then
     * never reached, the drawer stays open with the entered values, and the
     * mutation's own `onError` shows the notification.
     */
    const handleFormSubmit = async (values: PaymentIntent) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            size="xl"
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    );
};
